import {PaymentErrorMessage} from './payment-error-message.enum';

export interface PaymentErrorConfigs {
  [key: string]: PaymentErrorConfig;
}

export interface PaymentErrorConfig {
  showSupportLink: boolean;
  showErrorCode: boolean;
  staticMessageCode: PaymentErrorMessage | false;
}

export const stripeErrorConfig: PaymentErrorConfigs = {
  PAYS_001: {
    showSupportLink: false,
    staticMessageCode: false,
    showErrorCode: true
  },
  PAYS_002: {
    showSupportLink: false,
    staticMessageCode: false,
    showErrorCode: true
  },
  PAYS_003: {
    showSupportLink: false,
    staticMessageCode: PaymentErrorMessage.paymentRejected,
    showErrorCode: true
  },
  PAYS_004: {
    showSupportLink: false,
    staticMessageCode: false,
    showErrorCode: true
  },
  PAYS_005: {
    showSupportLink: false,
    staticMessageCode: PaymentErrorMessage.stripeProcessing,
    showErrorCode: true
  },
  PAYS_006: {
    showSupportLink: false,
    staticMessageCode: false,
    showErrorCode: true
  },
  DEFAULT: {
    showSupportLink: false,
    staticMessageCode: PaymentErrorMessage.paymentRejected,
    showErrorCode: false
  },
};
